import { Link } from "react-router-dom";
import { Button, Text } from "@nbs/ui";

export type NbsChartEmptyStateProps = {
  readonly message?: string;
  readonly onResetFilters?: () => void;
  readonly coverageHref?: string;
};

export function NbsChartEmptyState({
  message = "Aucune donnée pour ces filtres.",
  onResetFilters,
  coverageHref = "/dashboard#coverage",
}: NbsChartEmptyStateProps) {
  return (
    <div className="nbs-chart-container__empty nbs-chart-empty-state">
      <Text>{message}</Text>
      <div className="nbs-chart-empty-state__actions">
        {onResetFilters ? (
          <Button type="button" variant="secondary" onClick={onResetFilters}>
            Réinitialiser les filtres
          </Button>
        ) : null}
        <Link to={coverageHref}>Ouvrir la matrice de couverture</Link>
      </div>
    </div>
  );
}
